import React from 'react';

const LuckyNumberSection = props => (
  <section className="lucky-number-section">
    {props.children}
  </section>
);

export default LuckyNumberSection;
